const defaultState = {
	searchMonth: '',
	plants: [],
	plant: '',
	logTypes: [],
	logType: '',
	procId: '',
	message: '',
	chkFlag: '',
	resultList: [],
	pagingInfo: {
		currentPage: 1,
		pageUnit: 10,
		totalSize: 0
	},
	branches: [],
	services: [],
	langs: [],
	searchParams: {
		branch: '',
		service: '',
		lang: '',
		library: '',
		ver: ''
	}
};
export default {
	...JSON.parse(JSON.stringify(defaultState))
};
export { defaultState };
